import React from 'react';

import { MDText } from 'i18n-react';

import { VerifiedIcon } from '@motorway/mw-highway-code';

import LocalTexts from './WinningDealer.texts.json';

import styles from './WinningDealer.scss';

const LocalT = new MDText(LocalTexts);

export const WinningDealer = ({ dealer }: { dealer: string }) => (
  <div className={styles.winningDealer}>
    <h5 className={styles.title}>{LocalT.translate('buyer')}</h5>
    <div>
      <p data-thc-style-override className={styles.dealer}>{dealer}</p>
      <span aria-hidden="true" className={styles.icon}><VerifiedIcon filled /></span>
    </div>
    <p data-thc-style-override className={styles.subText}>{LocalT.translate('verifiedDealer')}</p>
  </div>
);
